import { render } from "./CommentBlock.vue?vue&type=template&id=7f33fb22&scoped=true"
import script from "./CommentBlock.vue?vue&type=script&lang=js"
export * from "./CommentBlock.vue?vue&type=script&lang=js"

import "./CommentBlock.vue?vue&type=style&index=0&id=7f33fb22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f33fb22"]])

export default __exports__